@if (popup) {
  <app-popup-header
    [title]="'HEADER.MY_PROFILE' | transloco"
    [closeable]="true"
    (closePopup)="onPopupClose()"
  ></app-popup-header>

  @if (isLoading) {
    <div class="loading loading-center"></div>
  }
  @else {
    <div class="mt-4">
      <label class="font-weight-normal">
        <input
          type="checkbox"
          name="Preferences"
          [(ngModel)]="hasForwardPreference"
          style="vertical-align: -3px;"
        >
        <span class="ml-2">{{ 'PROFILE_MANAGER.SET_AS_HOME_PAGE' | transloco }}</span>
      </label>
    </div>
  }

  <div class="footer row">
    <div class="col-12 px-0 text-right">
      @if (isSaving) {
        <span class="m-2">
          <img src="assets/loading_spinner.gif"/>
        </span>
      }
      <button type="button" class="btn btn-primary" (click)="savePreferences()">{{ 'ADMIN_PAGES.SAVE' | transloco }}</button>
    </div>
  </div>
}
